import React, {useEffect} from "react";
import {connect, useDispatch, useSelector} from "react-redux";

//antd
import {Menu, Dropdown, Button, message, Space, Tooltip} from "antd";
import {
  LogoutOutlined,
  UserOutlined,
  MenuFoldOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

//bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import {Nav, Navbar} from "react-bootstrap";

import {useHistory} from "react-router-dom";

//types
import {OPEN_LOGIN_POPUP, UNSET_USER} from "../store/user/types";

//dialog
import Login from "./Login";

//firebase
import {auth} from "../firebase/firebase";

//action
import {getInterviews} from "../store/user/action";

import $ from "jquery";

const NavBar = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const _id = localStorage.getItem("id");

  useEffect(() => {
    props.getInterviews(_id);
  }, []);

  const handleOpen = () => {
    dispatch({type: OPEN_LOGIN_POPUP});
  };
  const userType = localStorage.getItem("type");

  const {isAuth} = useSelector((state) => state.user);

  const handleLogout = () => {
    auth.signOut();
    dispatch({type: UNSET_USER});
    history.push("/");
  };

  const userData = JSON.parse(localStorage.getItem("Detail"));

  const menu = (
    <Menu>
      {isAuth && userType === "interviewee" && (
        <>
          <Menu.Item icon={<ClockCircleOutlined />} className="border-bottom">
            <Nav.Link href="/schedule" className="text-dark pl-0">
              Schedule Interview
            </Nav.Link>
          </Menu.Item>
          {/* <Nav.Link href="/payment">Payment</Nav.Link> */}
          {/* <Menu.Item icon={<MenuFoldOutlined />} className="border-bottom">
            <Nav.Link href="/interviewer" className="text-dark pl-0">
              Interviewer
            </Nav.Link>
          </Menu.Item> */}
          <Menu.Item icon={<UserOutlined />} className="border-bottom">
            <Nav.Link href="/profile" className="text-dark pl-0">
              Profile
            </Nav.Link>
          </Menu.Item>
        </>
      )}
      {isAuth && userType === "interviewer" && (
        <>
          {/* <Menu.Item icon={<MenuFoldOutlined />} className="border-bottom">
            <Nav.Link href="/interviewer" className="text-dark pl-0 ">
              Interviewer
            </Nav.Link>
          </Menu.Item> */}
          <Menu.Item icon={<ClockCircleOutlined />} className="border-bottom">
            <Nav.Link href="/avaiability" className="text-dark pl-0">
              Update Avaiability
            </Nav.Link>
          </Menu.Item>

          <Menu.Item icon={<UserOutlined />} className="border-bottom">
            <Nav.Link href="/profile" className="text-dark pl-0">
              Profile
            </Nav.Link>
          </Menu.Item>
        </>
      )}
      <Menu.Item
        onClick={handleLogout}
        icon={<LogoutOutlined />}
        className="py-2"
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Navbar
        collapseOnSelect
        expand="lg"
        bg="light"
        variant="light"
        className="p-3"
        sticky="top"
      >
        <Navbar.Brand href="/">
          <img
            alt=""
            src="/icon.png"
            width="50"
            height="50"
            className="d-inline-block"
          />{" "}
          PrepWithMock
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto"></Nav>

          <Nav>
            <Nav.Link href="/#about" className="font-weight-bold">
              What is PrepWithMock?
            </Nav.Link>
            <Nav.Link href="/#pricing">Pricing</Nav.Link>
            <Nav.Link href="/#testimonial">Stories</Nav.Link>
            <Nav.Link href="/#team">Meet the Team</Nav.Link>

            <Nav.Link href="/#contact">Contact</Nav.Link>
          </Nav>
          {isAuth ? (
            // <Button type="primary" onClick={handleLogout}>
            //   Logout
            // </Button>
            <Dropdown overlay={menu}>
              <Button
                placement="bottomCenter"
                style={{color: "#000", border: "none", background: "transparent"}}
                className="shadow-md"
              >
                Hello,&nbsp;{userData?.name}
              </Button>
            </Dropdown>
          ) : (
            <Button type="primary" onClick={handleOpen}>
              Login/ SignUp
            </Button>
          )}
        </Navbar.Collapse>
      </Navbar>
      <Login />
    </>
  );
};

export default connect(null, {getInterviews})(NavBar);
